import { render, staticRenderFns } from "./BannerEmployersStats.vue?vue&type=template&id=78474cff&scoped=true&"
import script from "./BannerEmployersStats.vue?vue&type=script&lang=js&"
export * from "./BannerEmployersStats.vue?vue&type=script&lang=js&"
import style0 from "./BannerEmployersStats.vue?vue&type=style&index=0&id=78474cff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78474cff",
  null
  
)

export default component.exports